import { z } from "zod";

export const featureDisabledResponseSchema = z.object({
    featureDisabled: z.literal(true),
});

export type FeatureDisabledResponse = z.infer<
    typeof featureDisabledResponseSchema
>;

export const FEATURE_DISABLED_RESPONSE: FeatureDisabledResponse = {
    featureDisabled: true,
};

export function isFeatureDisabledResponse(
    value: object,
): value is FeatureDisabledResponse {
    return featureDisabledResponseSchema.safeParse(value).success;
}
